import { takeLatest, call, put } from 'redux-saga/effects'
import * as constants from 'store/constants'
import api from './api'

function* getAtosLoginData({ payload }) {
    try {
        yield put({ type: constants.ATOS_LOGIN_LOADING, payload: true })

        const res = yield call(api.getAtosLoginData, payload)

        yield put({
            type: constants.ATOS_LOGIN_DATA,
            payload: res,
        })

        yield put({ type: constants.ATOS_LOGIN_LOADING, payload: false })
    } catch (e) {
        console.error(`${e.message}`)

        yield put({ type: constants.ATOS_LOGIN_ERROR, payload: e.message })
        yield put({ type: constants.ATOS_LOGIN_LOADING, payload: false })
    }
}

export default function* saga() {
    yield takeLatest(constants.GET_ATOS_LOGIN_DATA, getAtosLoginData)
}